import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.small.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { getSolidBackgroundShade } from 'utils/ui/colors';
import useFocusOnMount from 'hooks/useFocusOnMount';
import Alert from 'components/Alert';
import Box from 'components/Box';
import Button from 'components/Button';
import Status from 'components/Status';
import TextArea from 'components/TextArea';
import VisuallyHidden from 'components/VisuallyHidden';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CommentInput = styled(TextArea).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'size';
  }
}).withConfig({
  displayName: "CommentForm__CommentInput",
  componentId: "sc-1i8vnn6-0"
})(["min-height:auto;background-color:", ";border-radius:", ";font-size:", ";", ""], function (p) {
  return getSolidBackgroundShade(p.theme);
}, function (p) {
  return pxToRem(p.theme.globals.borderRadius.small);
}, function (p) {
  return p.theme.globals.typeScale.xs;
}, function (p) {
  return p.size === 'LARGE' && "\n\t\t@media (min-width: ".concat(p.theme.globals.breakpoints.m, ") {\n\t\t\tfont-size: ").concat(p.theme.globals.typeScale.m, ";\n\t\t}\n\t");
});
function CommentForm(_ref) {
  var _ref$focusOnMount = _ref.focusOnMount,
    focusOnMount = _ref$focusOnMount === void 0 ? false : _ref$focusOnMount,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue,
    inputLabel = _ref.inputLabel,
    submitButtonLabel = _ref.submitButtonLabel,
    submitSuccessMessage = _ref.submitSuccessMessage,
    submitErrorMessage = _ref.submitErrorMessage,
    submissionStatus = _ref.submissionStatus,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'DEFAULT' : _ref$size,
    onResetSubmitStatus = _ref.onResetSubmitStatus,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var inputRef = useFocusOnMount({
    disabled: !focusOnMount,
    onFocus: function onFocus(input) {
      return input.selectionStart = input.selectionEnd = (input === null || input === void 0 ? void 0 : input.value.length) || 0;
    }
  });
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var isDirty = message.trim().length > 0;
  function changeMessage(e) {
    setMessage(e.currentTarget.value);

    // Remove "Message sent!" feedback message when user starts
    // typing again after submitting one message
    if (['success', 'error'].includes(submissionStatus)) {
      onResetSubmitStatus();
    }
  }
  function handleSubmit(e) {
    e.preventDefault();
    var tmp = message;
    setMessage('');
    onSubmit(message).catch(function () {
      return setMessage(tmp);
    });
  }
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit,
    children: [/*#__PURE__*/_jsx(VisuallyHidden, {
      as: "label",
      htmlFor: "comment",
      children: inputLabel
    }), /*#__PURE__*/_jsx(CommentInput, {
      ref: inputRef,
      placeholder: inputLabel,
      id: "comment",
      maxRows: 5,
      size: size,
      value: message,
      onChange: changeMessage,
      onSubmit: handleSubmit
    }), isDirty && /*#__PURE__*/_jsx(Button, {
      type: "submit",
      variant: "primary",
      size: "medium",
      id: "feedback_form_inspector_submit_button",
      mt: "xs",
      children: submitButtonLabel
    }), /*#__PURE__*/_jsxs(Status, {
      children: [submissionStatus === 'success' && /*#__PURE__*/_jsx(VisuallyHidden, {
        children: submitSuccessMessage
      }), submissionStatus === 'error' && /*#__PURE__*/_jsx(Box, {
        mt: "xs",
        children: /*#__PURE__*/_jsx(Alert, {
          children: submitErrorMessage || t('error_generic')
        })
      })]
    })]
  });
}
export default CommentForm;